<template>
    <header class="site-search__header">
        <div class="site-search__header-inner">
            <h1 class="site-search__title visually-hidden">
                {{ props.title }}
            </h1>

            <div class="search-form__wrapper">
                <form class="search-form" method="get">
                    <label class="search-form__label visually-hidden" for="SiteSearch">
                        Search our site
                    </label>

                    <input
                        type="text"
                        id="SiteSearch"
                        name="q"
                        class="search-form__input"
                        placeholder="Search our site"
                        aria-label="Search our site"
                        v-model="props.query"
                        required />

                    <button class="search-form__button"
                            @click.prevent="triggerSearch(props.query)"
                            type="submit"
                            aria-label="search"
                            enterkeyhint="search" >
                        <span class="visually-hidden">Search</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <g clip-path="url(#clip0_1323_917)">
                                <path d="M0 6.49414C0 10.0748 2.91341 12.9883 6.49414 12.9883C7.91016 12.9883 9.20408 12.5326 10.2702 11.7676L14.2741 15.7796C14.4613 15.9668 14.7054 16.0563 14.9658 16.0563C15.5192 16.0563 15.9017 15.6413 15.9017 15.096C15.9017 14.8356 15.804 14.5996 15.6332 14.4288L11.6537 10.4248C12.4918 9.33433 12.9883 7.97526 12.9883 6.49414C12.9883 2.91341 10.0748 0 6.49414 0C2.91341 0 0 2.91341 0 6.49414ZM1.3916 6.49414C1.3916 3.67838 3.67838 1.3916 6.49414 1.3916C9.30992 1.3916 11.5967 3.67838 11.5967 6.49414C11.5967 9.30992 9.30992 11.5967 6.49414 11.5967C3.67838 11.5967 1.3916 9.30992 1.3916 6.49414Z" fill="black"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1323_917">
                                <rect width="16.2028" height="16.0563" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </button>
                </form>
            </div>

            <div class="site-search__nav" v-if="results && !loading" v-cloak>
                <ul class="search-nav">
                    <li v-for="(tab, tabIndex) in tabs" class="search-nav__item" role="tab" :key="tabIndex">
                        <a
                            :href="tab.link"
                            class="search-nav__link"
                            :class="{'search-nav__link--current': tab.isActive,
                                     ['search-nav__link--' + tab.name]: true,
                                     'search-nav__link--disabled': tab.totalResults === 0}"
                            :aria-selected="tab.isActive ? 'true' : 'false'">
                            <span class="search-nav__link-title">{{ tab.name }}
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </header>
</template>

<script setup>
import {ref, watch} from "vue";
import {getState} from "../services/stateful";

const props = defineProps({
    title: {
        type: Array,
        required: true,
    },
    query: {
        type: String,
        required: false,
        default: '',
    },
    results: {
        type: Array,
        required: true
    }
});

const searchFilterParam = 'filter';
const tabs = ref([]);
const triggerSearch = getState('Search.Trigger');

function searchFilterUrl(filter, page) {
    const url = new URL(window.location);

    url.searchParams.set(searchFilterParam, filter);

    url.searchParams.set('page', page);
    url.searchParams.set('q', props.query.trim());

    return url.toString();
}

function getTotalResultsForTab(filter) {
    return props.results.filter(result => result.collectionType === filter).length;
}

watch(() => props.results, (newResults) => {
    const search = new URLSearchParams(window.location.search);

    tabs.value = [
        {
            filter: 'all',
            name: 'All',
            link: searchFilterUrl('all', 1),
            isActive: !search.has(searchFilterParam) || search.get(searchFilterParam) === 'all',
            totalResults: props.results.length,
        },
        {
            filter: 'events',
            name: 'Events',
            link: searchFilterUrl('events', 1),
            isActive: search.has(searchFilterParam) && search.get(searchFilterParam) === 'events',
            totalResults: getTotalResultsForTab('events'),
        },
        {
            filter: 'posts',
            name: 'News',
            link: searchFilterUrl('posts', 1),
            isActive: search.has(searchFilterParam) && search.get(searchFilterParam) === 'posts',
            totalResults: getTotalResultsForTab('posts'),
        },
    ];
});
</script>


<style scoped>

</style>
